export default "__VITE_ASSET__6LQW7HBK__"